export default "__VITE_ASSET__9f73a6f4__"